import DesktopBanner from "../assets/images/Banner.png";
import MobileBanner from "../assets/images/Home-Mobilebanner.jpg";
import "./Blogs.css";
import Blog1Image from "../assets/images/Blog1.png";
import Blog2Image from "../assets/images/Blog2.png";
import Blog3Image from "../assets/images/Blog3.jpeg";

const Blogs = () => {
  const blogPosts = [
    {
      id: 1,
      image: Blog1Image,
      title: "From the Vet’s Desk: Why Natural Chews Are Changing Pet Care",
      date: "September 09, 2025",
      readTime: "10 mins read",
      redirectUrl:
        "https://www.linkedin.com/pulse/from-vets-desk-why-natural-chews-changing-pet-care-pupntreats-ldw0c/?trackingId=CM0sQjMpQ4ujbd9%2BRYDsSA%3D%3D",
    },
    {
      id: 2,
      image: Blog2Image,
      title: "Building Trust Through Transparency: The Pup N Treats Way",
      date: "September 22, 2025",
      readTime: "15 mins read",
      redirectUrl:
        "https://www.linkedin.com/pulse/building-trust-through-transparency-pup-n-treats-way-pupntreats-2sv8c/?trackingId=uDka7K3TR5OORPWEGOg%2Bog%3D%3D",
    },
    {
      id: 3,
      image: Blog3Image,
      title:
        "Chews and Children: Teaching Families the Value of Responsible Pet Care",
      date: "September 06, 2025",
      readTime: "10 mins read",
      redirectUrl:
        "https://www.linkedin.com/pulse/chews-children-teaching-families-value-responsible-pet-care-vintc/?trackingId=pV93qjG6SfqqaQzyTLlaSw%3D%3D",
    }
  ];

  return (
    <>
      <div style={{ fontFamily: "Arial, sans-serif", overflowX: "hidden" }}>
        {/* Banner Section - Starts from absolute top */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "800px",
            overflow: "hidden",
          }}
        >
          <img
            src={DesktopBanner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
            className="desktop-banner"
          />

          <img
            src={MobileBanner}
            alt="Banner"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
            className="mobile-banner"
          />

          <style>{`
            @media (max-width: 768px) {
              .desktop-banner {
                display: none !important;
              }
              .mobile-banner {
                display: block !important;
              }
            }
          `}</style>
        </div>
      </div>

      <div className="container pt-5 mb-5">
        {/* <h1 className="blogs-section-title text-center">Popular Blogs</h1> */}

        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 justify-content-center">
          {blogPosts.map((post) => (
            <div key={post.id} className="col d-flex">
              <div className="blog-card w-100">
                <img
                  src={post.image}
                  className="blog-card-image"
                  alt={`Blog Post: ${post.title}`}
                />
                <div className="blog-card-body">
                  <h5 className="blog-card-title">{post.title}</h5>
                  <div className="blog-meta">
                    <span>{post.date}</span>
                    <span>{post.readTime}</span>
                  </div>
                  <a
                    href={post.redirectUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="read-more-link"
                  >
                    Read more
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Blogs;
